import axiosInstance from "../../utility/axiosInstance";

// types and state
// import { setLoading, stopLoading } from "../../store/slices/loading";

import { toast } from "sonner";
// import { setMessage } from "../../store/slices/message";
import { GetInterviewResponse } from "../../store/types/interview";
import { setMessage } from "../../store/slices/message";
import { isAxiosError } from "axios";
import { cancelInterview, deleteInterview } from "../../store/slices/interview";
import { AppDispatch } from "../../store";

export const getInterviewById = async (
  interviewId: string,
  id: string
): Promise<GetInterviewResponse> => {
  const response = await axiosInstance.get(
    `/interview/evaluation?interviewId=${interviewId}&candidateId=${id}`
  );
  return response.data;
};

export const delete_interview = async (
  dispatch: AppDispatch,
  id: string,
  onSuccess?: () => void
): Promise<void> => {
  try {
    const response = await axiosInstance.delete(`/interviews/${id}`);

    const { data } = response.data;
    dispatch(deleteInterview(data));
    toast.success(response.data?.message || "Interview deleted successfully");
    dispatch(
      setMessage({
        message: "Interview Deleted Successfully",
        type: "success",
        title: "Successful",
      })
    );
    
    // Call the onSuccess callback if provided to refetch data
    if (onSuccess) {
      onSuccess();
    }
  } catch (error: any) {
    if (isAxiosError(error)) {
      const errorMessage = error?.response?.data?.message || "Failed to delete interview";
      toast.error(errorMessage);
      dispatch(
        setMessage({
          message: errorMessage,
          type: "error",
          title: "Failed",
        })
      );
    }
    throw error;
  }
};

export const cancel_interview = async (
  dispatch: AppDispatch,
  id: string,
  navigate: Function
): Promise<void> => {
  try {
    const handleSuccess = async () => {
      navigate("/interviews");
      // Small delay to ensure navigation happens before reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    };
    const response = await axiosInstance.delete(`/interviews/${id}/cancel`);

    const { data } = response.data;
    dispatch(cancelInterview(data));
    toast.success(response.data?.message);
    dispatch(
      setMessage({
        message: "Interview canceled successfully",
        // message: response.data?.message,
        type: "success",
        title: "Successful",
      })
    );
    handleSuccess();
    navigate(`/interviews`);
  } catch (error: any) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
      dispatch(
        setMessage({
          message: error?.response?.data?.message,
          type: "error",
          title: "Failed",
        })
      );
    }
  }
};

export const reprocess_video = async (
  interviewId: string
): Promise<any> => {
  const response = await axiosInstance.post(
    `/interviews/${interviewId}/reprocess-video`
  );
  return response.data;
};
